<template>
    <div>
        <component :is="layout">
            <router-view/>
        </component>
    </div>
</template>


<style>
    @import 'font-awesome/css/font-awesome.css';
    @import './assets/styles/animate.css';
    @import 'metismenu/dist/metisMenu.css';
    @import './assets/fonts/pe-icon-7-stroke/css/pe-icon-7-stroke.css';
    @import './assets/fonts/pe-icon-7-stroke/css/helper.css';
    @import './assets/styles/style.css';
    @import './assets/styles/custom.css';
    @import 'vue-multiselect/dist/vue-multiselect.min.css';

</style>

<script>
    import Vue from 'vue'

    import {customValidations} from './directives/customValidations'
    import {monto} from './directives/montoSoles'
    import {montoNull} from './directives/montoNull'
    import {duration, kms, percentage, valueDash} from './directives/directives'
    import {porcentajeArrow} from './directives/porcentajeArrow'
    import {soloNumeros} from './directives/soloNumeros'
    import Vuelidate from 'vuelidate'
    import {HomerInit} from './assets/scripts/homer'
    import Paginate from 'vuejs-paginate'
    import * as VueGoogleMaps from 'vue2-google-maps'
    import InvisibleRecaptcha from 'vue-invisible-recaptcha'
    import VueTelInput from 'vue-tel-input'
    import {usd} from './directives/currency'
    import { VueMaskDirective } from 'v-mask'

    Vue.directive('mask', VueMaskDirective);

    Vue.directive('customValidations', customValidations);

    Vue.directive('monto', monto);

    Vue.directive('montoNull', montoNull);

    Vue.directive('percentage', percentage);

    Vue.directive('porcentajeArrow', porcentajeArrow);

    Vue.directive('soloNumeros', soloNumeros);

    Vue.component('paginate', Paginate);

    Vue.component('invisible-recaptcha', InvisibleRecaptcha);

    Vue.directive('usd', usd);
    Vue.directive('valueDash', valueDash);
    Vue.directive('kms', kms);
    Vue.directive('dur', duration);

    Vue.use(VueTelInput) // Define default global options here (optional)


    Vue.use(VueGoogleMaps, {
        load: {
            key: process.env.GOOGLE_MAPS_API_KEY,
            libraries: 'places',
            region: 'ES',
            language: 'es',
        },
    });

    Vue.use(Vuelidate);

    const default_layout = "user";

    export default {
        components: {},
        computed: {
            layout() {
                return (this.$route.meta.layout || default_layout) + "-layout";
            }
        },
        created() {

        },
        updated() {

        },
        mounted() {
            HomerInit();
        }
    }
</script>



// WEBPACK FOOTER //
// src/App.vue